export var ImageFormats;
(function (ImageFormats) {
    ImageFormats["JPEG"] = "jpeg";
    ImageFormats["JPG"] = "jpg";
    ImageFormats["PNG"] = "png";
    ImageFormats["WEBP"] = "webp";
    ImageFormats["GIF"] = "gif";
    ImageFormats["SVG"] = "svg+xml";
    ImageFormats["TIFF"] = "tiff";
    ImageFormats["PDF"] = "pdf";
})(ImageFormats || (ImageFormats = {}));
export var ValidationType;
(function (ValidationType) {
    ValidationType["size"] = "size";
    ValidationType["dimensions"] = "dimensions";
    ValidationType["format"] = "format";
})(ValidationType || (ValidationType = {}));
//# sourceMappingURL=image-validations.js.map